import { render } from "./ApiErrorDisplay.vue?vue&type=template&id=07f1f12b&ts=true"
import script from "./ApiErrorDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiErrorDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./ApiErrorDisplay.vue?vue&type=style&index=0&id=07f1f12b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/api/ApiErrorDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07f1f12b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07f1f12b', __exports__)) {
    api.reload('07f1f12b', __exports__)
  }
  
  module.hot.accept("./ApiErrorDisplay.vue?vue&type=template&id=07f1f12b&ts=true", () => {
    api.rerender('07f1f12b', render)
  })

}


export default __exports__